export enum IntegrationEvent {
    IMPORT_ENDED = 'import-ended',
}
